<template>
  <div class="c-halt-indicator" v-if="showHaltIcon">
    <img v-b-tooltip.hover :title="toolTiptext" :src="haltIcon" class="trd-hlt-icon-class" />
  </div>
</template>

<script>
export default {
  name: 'c-halt-indicator',
  props: {
    tradeHaltValue: {
      type: String,
      default: '',
      required: true
    },
    toolTipRequired: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    haltIcon() {
      return this.isValidTradingHaltValue()
        ? require(`@/assets/halt-icons/Halt-${this.tradeHaltValue.trim()}.svg`)
        : '';
    },
    toolTiptext() {
      return this.isValidTradingHaltValue() && this.toolTipRequired
        ? this.$t(`white-label.globalLabels.tradingHalt.${this.tradeHaltValue.trim()}`)
        : '';
    },
    showHaltIcon() {
      return this.isValidTradingHaltValue();
    }
  },
  methods: {
    isValidTradingHaltValue() {
      if (this.tradeHaltValue) {
        return ['H', 'R', 'S', 'CD', 'OD'].includes(this.tradeHaltValue.trim());
      } else return false;
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-halt-indicator';
</style>
